/**
 * 微信js-sdk
 * 参考文档：https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
 */
import { get } from './request'
import { wxSdk } from './wxsdk'

export const wxConfigRegister = () => {
    const callback = window.location.href
    const wechatConfig = async () => {
        const result = await get('/wechat_web/jssdk', {
            callback: encodeURI(callback)
        })
        if (result) {
            console.log('result',result)
            wxSdk.wxConfig(result)
        }
    }
    wechatConfig()
}

export const wxShareRegister = (option) => {
    wxSdk.wxShare(option)
}